import React from 'react';

const InfoCard = ({ icon: Icon, title, description }) => (
    <div className="group hover-lift transition-all duration-500 transform hover:scale-105">
        <div className='relative bg-card  cursor-default p-8 shadow-xl hover:shadow-2xl min-h-64 flex flex-col justify-center items-center rounded-3xl overflow-hidden transition-all duration-500 hover:rotate-1'>
            
            {/* Animated background overlay */}
            <div className="absolute inset-0 bg-gradient-to-r from-white/10 to-white/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            
            {/* Floating animation circle */}
            <div className="absolute top-4 right-4 w-16 h-16 bg-white/10 rounded-full animate-pulse group-hover:animate-ping"></div>
            
            {/* Icon container with enhanced animations */}
            <div className='mb-6 relative z-10 transform group-hover:scale-110 transition-all duration-500'>
                <div className="absolute inset-0 bg-white/20 rounded-full scale-0 group-hover:scale-150 transition-transform duration-500 animate-pulse-ring"></div>
                <div className="relative p-4 bg-gradient-to-br from-white/20 to-white/10 rounded-full backdrop-blur-sm group-hover:bg-white/30 transition-all duration-300">
                    <Icon 
                        size={64} 
                        className="text-[#e6dbc9] mx-auto group-hover:text-white transition-all duration-300 group-hover:animate-wiggle" 
                    />
                </div>
            </div>
            
            {/* Title with gradient text effect */}
            <h1 className='text-white font-bold text-2xl text-center mb-4 relative z-10 group-hover:text-[#e6dbc9] transition-colors duration-300 transform group-hover:scale-105'>
                {title}
            </h1>
            
            {/* Description with better spacing and effects */}
            <p 
                dir='rtl' 
                className='text-center text-lg text-white/90 leading-relaxed relative z-10 group-hover:text-white transition-all duration-300 max-w-xs group-hover:font-medium'
            >
                {description}
            </p>
            
            {/* Animated border effect */}
            <div className="absolute inset-0 border-2 border-white/20 rounded-3xl group-hover:border-white/40 transition-colors duration-300"></div>
            
            {/* Shine effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-3xl"></div>
        </div>
    </div>
);

export default InfoCard;
